import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const DatePicker = ({ value, onChange, testId = "date-picker" }) => {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : null;
  const date = d && isValid(d) ? d : null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="flex h-9 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-sm hover:border-zinc-400">
          <span className={date ? "font-mono" : "text-zinc-400"}>{date ? format(date, "dd/MM/yyyy") : "DD/MM/YYYY"}</span>
          <CalendarDays className="h-4 w-4 text-zinc-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testId}-popover`}>
        <Calendar mode="single" weekStartsOn={1} selected={date || undefined} defaultMonth={date || undefined}
          onSelect={(v) => { if (v) { onChange(format(v, "yyyy-MM-dd")); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
